import {
	isNullField,
	shouldShowRangeInput,
	isCalFamily
} from 'components/Preview/filter/FilterCondition';
import moment from 'moment';
import {
	DC_INV_VIEW_LIST,
	WM_YR_WK_NO,
	STR_ORDER_LIST,
	STR_ORDER_FIELDS_WITH_FUZZY,
	STR_TMPT_LIST,
	WALMART_CALENDAR,
	PURCHASE_ORDER_LIST,
	PO_DATE_LIST,
	YEAR_KEY,
	QUARTER_KEY,
	MONTH_KEY,
	WEEK_KEY,
	DATE_KEY,
	FILTER_CONDITION_LABELS,
	WALMART_WEEK_START_DATE,
	WM_ROLL_YEAR,
	DC_TMPT_LIST,
	PIVOT_SINGLE_TIME_VALUE_MAP,
	PO_DEFAULT_FILTER_MAP
} from 'constants/constant';
import { getTableName } from 'components/Preview/Preview.utils';
import { getTemplateId, isCustomDataset } from './utils';
import { isMTS } from 'components/Preview/filter/FilterCondition';
import { getKeyByValue } from 'helper/helper';
import { WM_ROLL_QTR } from 'constants/constant';
import { WM_ROLL_MONTH } from 'constants/constant';
import { WM_ROLL_WEEK } from 'constants/constant';
import { CAL_ROLL_YEAR } from 'constants/constant';
import { CAL_ROLL_QTR } from 'constants/constant';
import { CAL_ROLL_MONTH } from 'constants/constant';
import { CAL_ROLL_WEEK } from 'constants/constant';
import { INVENTORY_DATE } from 'constants/constant';
import { BUSINESS_DATE } from 'constants/constant';
import { CAL_ROLL_DAY } from 'constants/constant';
import { REGISTER_SALES_LIST } from 'constants/constant';
import { HISTORICAL_REPORT_OMNI } from 'constants/constant';

const cDateRange = '_cDateRange';
const cDateRangev1 = '_cDateRangev1';
const cCustomRange = '_cCustomDateRange';

const callFnMap = (condition, dType) => {
	let fn = {
		'is equal to': '_cIsEqualTo',
		'is not equal to': dType === 'number' ? '_nIsNotEqualTo' : '_sIsNotEqualTo',
		'has any of': '_cIsEqualTo',
		'has all of': '_cHasAllOf',
		'is greater than': '_nGreaterThan',
		'is greater than or equal to': '_nNotGreaterThan',
		'is less than': '_nLessThan',
		'is less than or equal to': '_nNotLessThan',
		'is in between': '_nIsBetween',
		'is null': '_cIsNull',
		'is not null': dType === 'number' ? '_nIsNotNull' : '_sIsNotNull',
		contains: '_sContains',
		"doesn't contain": '_sDoesntContains',
		'start with': '_sStartWith',
		"doesn't start with": '_sDoesntStartWith',
		'ends with': '_sEndsWith',
		"doesn't end with": '_sDoesntEndsWith'
	};

	return fn[condition];
};

/**
 * | _c - common for both number and string
 * | _n - function for number
 * | _s - function for string
 */

/***
 *  date attributes available in dimension and metrics.
 */

const callDtFnMap = (condition) => {
	let fn = {
		'is equal to': '_cIsDtEqualTo',
		'is greater than': '_cDtGreaterThan',
		'is greater than or equal to': '_cDtGreaterOrEqualTo',
		'is less than': '_cDtLessThan',
		'is less than or equal to': '_cDtLessThanOrEqualTo',
		Custom: '_cCustomDateRange'
	};

	return fn[condition];
};

const callFormatter = (fnMap) => {
	let fn = {
		_cIsEqualTo: (el) => el,
		_cHasAllOf: (el) => el,
		_nIsNotEqualTo: (el) => `not ${el}`,
		_nGreaterThan: (el) => `>${el}`,
		_nNotGreaterThan: (el) => `>=${el}`,
		_nLessThan: (el) => `<${el}`,
		_nNotLessThan: (el) => `<=${el}`,
		_nIsBetween: (el) => el,
		_nIsNotNull: () => 'NOT NULL',
		_sIsEqualTo: (el) => el,
		_sIsNotEqualTo: (el) => `-${el}`,
		_sContains: (el) => `%${el}%`,
		_sDoesntContains: (el) => `-%${el}%`,
		_sStartWith: (el) => `${el}%`,
		_sDoesntStartWith: (el) => `-${el}%`,
		_sEndsWith: (el) => `%${el}`,
		_sDoesntEndsWith: (el) => `-%${el}`,
		_cIsNull: () => 'NULL',
		_sIsNotNull: () => '-NULL',
		_cCustomDateRange: (el) => {
			const newDt = moment(el[1], 'YYYY/MM/DD').clone().add(1, 'day').format('YYYY/MM/DD');
			return `${el[0]} to ${newDt}`;
		},
		_cDateRange: (el) => `${el}`,
		_cDateRangev1: (el) => `[${el.join(', ')}]`,
		_cMultiDateRange: (el) => `${el.join(', ')}`,
		_cIsDtEqualTo: (el) => `${el[0]}`,
		_cDtGreaterThan: (el) => {
			const newDt = moment(el[1], 'YYYY/MM/DD').clone().add(1, 'day').format('YYYY/MM/DD');
			return `after ${newDt}`;
		},
		_cDtGreaterOrEqualTo: (el) => {
			return `after ${el[0]}`;
		},
		_cDtLessThan: (el) => {
			return `before ${el[0]}`;
		},
		_cDtLessThanOrEqualTo: (el) => {
			const newDt = moment(el[1], 'YYYY/MM/DD').clone().add(1, 'day').format('YYYY/MM/DD');
			return `before ${newDt}`;
		}
	};

	return fn[fnMap];
};

const getTblName = (view, o, isMultiTimeFilter = false) => {
	const {
		table,
		tableWeeklyMultiWindow,
		filter: { condition },
		filterTable,
		parent
	} = o;
	/**
	 * Below table is hardcoded because this will not come in API response and
	 * this will help in scheduling REOCCURING report.
	 */
	if (condition !== FILTER_CONDITION_LABELS.CUSTOM) {
		if (isMultiTimeFilter) {
			return tableWeeklyMultiWindow;
		}

		if (filterTable !== undefined) {
			return filterTable;
		}
		if (parent === '') {
			return table;
		}
		return 'vw_chnl_perf_calendar_dim';
	}

	if (filterTable !== undefined) {
		return filterTable;
	}

	const retTbl = getTableName(view);
	if (retTbl !== undefined) {
		return retTbl;
	}

	return table;
};

const getColName = (view, o, isFuzzyOption, isMultiTimeFilter = false) => {
	const {
		filter: { condition },
		businessName,
		parent,
		filterAttribute
	} = o;
	const removeSpace = condition.trim();

	if (parent === WALMART_CALENDAR) {
		// below logic common for store and omni
		if (businessName === YEAR_KEY) return isFuzzyOption ? WALMART_WEEK_START_DATE : WM_ROLL_YEAR;
		if (businessName === QUARTER_KEY) return isFuzzyOption ? WALMART_WEEK_START_DATE : WM_ROLL_QTR;
		if (businessName === MONTH_KEY) return isFuzzyOption ? WALMART_WEEK_START_DATE : WM_ROLL_MONTH;
		if (isMultiTimeFilter && condition !== FILTER_CONDITION_LABELS.CUSTOM) {
			return WM_ROLL_WEEK;
		}
		return filterAttribute;
	} else {
		if (businessName === YEAR_KEY) return CAL_ROLL_YEAR;
		if (businessName === QUARTER_KEY) return CAL_ROLL_QTR;
		if (businessName === MONTH_KEY) return CAL_ROLL_MONTH;
		if (businessName === WEEK_KEY && removeSpace !== FILTER_CONDITION_LABELS.CUSTOM)
			return CAL_ROLL_WEEK;
		if (businessName === WEEK_KEY && removeSpace === FILTER_CONDITION_LABELS.CUSTOM) {
			if (DC_INV_VIEW_LIST.includes(view)) {
				return INVENTORY_DATE;
			}
			return BUSINESS_DATE;
		}
		if (businessName === DATE_KEY && removeSpace === FILTER_CONDITION_LABELS.YESTERDAY)
			return CAL_ROLL_DAY;
		if (businessName === DATE_KEY && removeSpace === FILTER_CONDITION_LABELS.MONTH_TO_DATE)
			return CAL_ROLL_MONTH;
		if (businessName === DATE_KEY && removeSpace === FILTER_CONDITION_LABELS.QUARTER_TO_DATE)
			return CAL_ROLL_QTR;
		if (businessName === DATE_KEY && removeSpace !== FILTER_CONDITION_LABELS.CUSTOM)
			return CAL_ROLL_WEEK;
		if (businessName === DATE_KEY && removeSpace === FILTER_CONDITION_LABELS.CUSTOM) {
			if (DC_INV_VIEW_LIST.includes(view)) {
				return INVENTORY_DATE;
			}
			return BUSINESS_DATE;
		}
		/* This return column name for Purchase order */
		if (parent === '') {
			if (businessName === PO_DATE_LIST.wmtCalendar)
				return PIVOT_SINGLE_TIME_VALUE_MAP.WMT_YEAR_AND_WEEK;
			if (businessName === PO_DATE_LIST.mustArriveDate)
				return PO_DEFAULT_FILTER_MAP.MUST_ARRIVE_BY_DATE;
			if (businessName === PO_DATE_LIST.receivedDate) return PO_DEFAULT_FILTER_MAP.RECEIVED_DATE;
			if (businessName === PO_DATE_LIST.poCreateDay)
				return PO_DEFAULT_FILTER_MAP.PURCHASE_ORDER_CREATED_TIMESTAMP;
			if (businessName === PO_DATE_LIST.poShipDate)
				return PO_DEFAULT_FILTER_MAP.DO_NOT_SHIP_BEFORE_DATE;
		}
		return CAL_ROLL_DAY;
	}
};

const build = (o, view, userPersona, isMultiTimeFilter = false, templateNumber) => {
	const {
		filter: { condition, value, extraValue },
		table,
		technicalName,
		dbtechnicalName,
		columnFormatFlag,
		dataType,
		parent,
		businessName,
		weekEndReporting
	} = o;
	let techColName = columnFormatFlag ? dbtechnicalName : technicalName;

	// Need fuzzy option field only if it is SSI and supplier
	const templateId = isCustomDataset(templateNumber) ? templateNumber : getTemplateId(view);
	const isFuzzyOption =
		STR_TMPT_LIST.includes(templateId) ||
		DC_TMPT_LIST.includes(templateId) ||
		REGISTER_SALES_LIST.includes(templateId) ||
		HISTORICAL_REPORT_OMNI.includes(templateId) ||
		isCustomDataset(templateId);

	if (isCalFamily(o)) {
		//default value;
		let valList = [-1, -1];

		if (condition === FILTER_CONDITION_LABELS.CUSTOM) {
			valList = callFormatter(cCustomRange)(value);
		} else {
			/**
			 * | if parent is WM and condn is week and date => go for new approach else old
			 */
			let fn = cDateRangev1;
			if (parent === WALMART_CALENDAR) {
				// if it is not MTS and Last weekend, then return weekEndReporting[0], otherwise, dont
				if (condition === FILTER_CONDITION_LABELS.WEEKEND && !isMTS(o)) {
					return weekEndReporting?.[0];
				}
				if ([WEEK_KEY, DATE_KEY].includes(businessName)) {
					fn = cDateRange;
				}
			}
			if (parent === '' && PURCHASE_ORDER_LIST.includes(templateId)) {
				const key = getKeyByValue(PO_DATE_LIST, businessName);
				if (key) {
					fn = cDateRange;
				}
			}

			valList = callFormatter(fn)(value);
		}
		const tableName = getTblName(view, o, isMultiTimeFilter);
		const columnName = getColName(view, o, isFuzzyOption, isMultiTimeFilter);

		// New Return
		return { [`${tableName}.${columnName}`]: valList };
	}

	if (dataType === 'date') {
		let valList = callFormatter(cCustomRange)(value);
		/* Forecast WM Field */
		if (o.businessName === WM_YR_WK_NO) {
			let _val = [...value];
			if (condition === FILTER_CONDITION_LABELS.CUSTOM) {
				_val = [...extraValue];
			}
			/*
			 * | Below col name for all fuzzy option(except custom)
			 */
			techColName = WM_ROLL_WEEK;
			valList = callFormatter(cDateRange)(_val);
		} else if (
			condition !== FILTER_CONDITION_LABELS.CUSTOM &&
			STR_ORDER_LIST.includes(templateId) &&
			STR_ORDER_FIELDS_WITH_FUZZY.includes(o.businessName)
		) {
			/** Order forecast has 4 fields with fuzzy options */
			valList = callFormatter(cDateRange)(value);
		} else {
			const fnMap = callDtFnMap(condition);
			valList = callFormatter(fnMap)(value);
		}

		return {
			[`${table}.${techColName}`]: `${valList}`
		};
	}

	/**
	 * replace comma(,) with ^,;
	 */
	const replaceCommaList = value.map((c) => c.replaceAll(',', '^,'));
	const fnMap = callFnMap(condition, dataType);
	let valList =
		condition === ''
			? ''
			: !isNullField(condition)
			? replaceCommaList.map(callFormatter(fnMap))
			: callFormatter(fnMap)();
	if (shouldShowRangeInput(condition)) {
		valList = `[${valList.sort()}]`;
	} else {
		valList = valList.toString();
	}
	return {
		[`${table}.${techColName}`]: `${valList}`
	};
};

export { build };
